<ng-container *ngIf="mostraFiltroDisponibilita" >



    <ng-container *ngIf="!mostraCaricamentoDisponibilitaUVM">
        
        <div>
            <strong>1 - Elenco qualifiche disponibili</strong>
            <div>
                <mat-form-field>
                    <mat-label>Cerca qualifica</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Infermiere" #input>
                </mat-form-field>

                <table mat-table [dataSource]="dataSource">



                    <ng-container matColumnDef="descrizione">
                        <th mat-header-cell *matHeaderCellDef> Qualifica </th>
                        <td mat-cell *matCellDef="let element"> {{element.descrizione}} </td>
                    </ng-container>


                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let element"> <button mat-button
                                (click)="addToSelected(element)" *ngIf="this.mostraAggiungi"><mat-icon aria-hidden="false"
                                    aria-label="Aggiungi icona" fontIcon="add"></mat-icon> Aggiungi</button> </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">Nessun dato trovato per "{{input.value}}"</td>
                    </tr>


                </table>

                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
                    aria-label="Select page of periodic elements">
                </mat-paginator>
            </div>
        </div>

        <div>
            <strong>2 - Qualifica selezionata</strong>
            <button mat-button (click)="svuotaListaQualifiche()"><mat-icon aria-hidden="false"
                    aria-label="Aggiungi icona" fontIcon="cancel"></mat-icon>Svuota lista</button>
            <table mat-table [dataSource]="dataSoruceSelected">



                <ng-container matColumnDef="descrizione">
                    <th mat-header-cell *matHeaderCellDef> Qualifica selezionata </th>
                    <td mat-cell *matCellDef="let element"> {{element.descrizione}} </td>
                </ng-container>


                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element"> <button mat-button
                            (click)="rimuoviDaListaQualificheSelezionate(element)"><mat-icon aria-hidden="false"
                                aria-label="Aggiungi icona" fontIcon="delete"></mat-icon> Rimuovi</button> </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <tr class="mat-row " *matNoDataRow>
                    <td class="mat-cell no-results-row" [attr.colspan]="displayedColumns.length">
                        <div class="alert alert-warning " role="alert">
                            Nessun qualifica selezionata.
                        </div>
                    </td>
                </tr>


            </table>


        </div>

    </ng-container>



                            <button mat-flat-button (click)="saveQualifiche()" class="mt-4" [disabled]="this.mostraAggiungi">
                                <mat-icon>arrow_forward</mat-icon>Avanti
                            </button>

</ng-container>




